import {
  createAirPricingRecords,
  createMultiCurrencyAirPricingRecords,
  MockAirPricingRecords,
  MockMultiCurrencyAirPricingRecords,
} from '@dapi/sdk/spec';
import {
  multiCurrencyPrice,
  price,
} from './price';
import {
  MultiUnitPrice,
  unitPrice,
} from './unit-price';

export const airPricingRecords: MockAirPricingRecords = createAirPricingRecords({
  template: {
    totalPrices: [price],
    unitPrices: [unitPrice]
  }
});

export const multiCurrencyAirPricingRecords: MockMultiCurrencyAirPricingRecords = createMultiCurrencyAirPricingRecords({
  template: {
    totalPrices: [multiCurrencyPrice],
    unitPrices: [MultiUnitPrice]
  }
});

